import React from "react";
import { Paper, Text, Radio, Stack } from "@mantine/core";

const QuizQuestionCard = ({ question, selectedOption, onSelect }) => (
  <Paper p="lg" withBorder radius="md" mt="md">
    <Text weight={600} mb="md">
      {question.questionText}
    </Text>
    <Radio.Group
      value={selectedOption !== undefined ? String(selectedOption) : ""}
      onChange={(value) => onSelect?.(Number(value))}
    >
      <Stack spacing="sm">
        {(question.options ?? []).map((option, index) => (
          <Radio
            key={index}
            value={String(index)}
            label={option.text}
          />
        ))}
      </Stack>
    </Radio.Group>
  </Paper>
);

export default QuizQuestionCard;
